import { getListViewMaxWidth } from './getMaxWidths';
import { isReadingPanePositionRight } from '../selectors/readingPanePosition';
import getColumnMinWidth, { getReceivedColumnMinWidth } from './getColumnMinWidth';
import type MailListColumnHeaderType from '../types/MailListColumnHeaderType';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';

export function getMLColumnHeaderDefaultWidths(sortColumnHeaderType?: MailListColumnHeaderType): {
    senderColumnWidth: number;
    subjectColumnWidth: number;
    receivedColumnWidth: number;
    sortedContentColumnWidth: number;
} {
    // default width and min width are the same for sender and received columns.
    // since there is no set default width for subject column, keep it as 92 so it never
    // disappears completely.
    const defaultSenderColumnWidth = getColumnMinWidth(0);

    const isReadingPaneRight = isReadingPanePositionRight();

    // Column header width includes content + right padding + left padding + scrollbar space
    // Naming of this file is confusing because Listview implies the actual rows, but the returned widths are for the column headers
    const defaultReceivedColumnWidth: number = getReceivedColumnMinWidth(
        true /* isColumnHeader */,
        isReadingPaneRight
    );

    const defaultSortedContentColumnWidth =
        isGlobalFeatureEnabled('tri-sortFilter4thColumn') && sortColumnHeaderType
            ? getColumnMinWidth(sortColumnHeaderType)
            : 0;

    // subject column takes the remaining space
    const defaultSubjectColumnWidth =
        getListViewMaxWidth() -
        defaultSenderColumnWidth -
        defaultReceivedColumnWidth -
        defaultSortedContentColumnWidth;

    return {
        senderColumnWidth: defaultSenderColumnWidth,
        subjectColumnWidth: defaultSubjectColumnWidth,
        receivedColumnWidth: defaultReceivedColumnWidth,
        sortedContentColumnWidth: defaultSortedContentColumnWidth,
    };
}
